





















































import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { usersCollection, inventoryCollection, Timestamp } from "../db";

@Component
export default class EquipmentWorkToDo extends Vue {
  @Getter checklistReceived;
  @Getter user;

  private equipmentWorkToDoCollection;
  private equipmentWorkToDo: any[] = [];

  @Prop({ required: true })
  public item: any;

  private isFirstRun = true;

  async created() {
    this.equipmentWorkToDoCollection = inventoryCollection
      .doc(this.item.id)
      .collection("workToDo");

    this.$bind("equipmentWorkToDo", this.equipmentWorkToDoCollection, {
      wait: true,
    });
  }

  orderedList(items) {
    // Vue was freaking out if I sort the array, mapping to new object is hack but it works
    return items.map((x) => {
      return {
        id: x.id,
        text: x.text,
        complete: x.complete,
        completeDate: x.completeDate,
        created: x.created,
        user: x.user ? x.user.displayName : "",
      };
    });
  }

  async add() {
    await this.equipmentWorkToDoCollection.add({
      text: "",
      complete: false,
      completeDate: null,
      created: Timestamp.now(),
    });
  }
  async checkChange($event, id) {
    await this.equipmentWorkToDoCollection.doc(id).update({
      complete: $event,
      completeDate: $event ? Timestamp.now() : "",
      user: $event ? usersCollection.doc(this.user.id) : "",
    });
  }

  async textChange($event, id) {
    await this.equipmentWorkToDoCollection.doc(id).update({
      text: $event,
    });
  }

  async remove(id) {
    await this.equipmentWorkToDoCollection.doc(id).delete();
  }

  getFormattedDate(date) {
    const year = date.getFullYear();
    const month = (1 + date.getMonth()).toString();
    const day = date.getDate().toString();
    return month + "/" + day + "/" + year;
  }
}
